  <div class="flex flex-col items-center gap-2">
      <app-create-entity-button></app-create-entity-button>
    <div class="flex flex-col menu-button" routerLink="/shipments">
      <button matButton><app-icon icon="shipment"></app-icon></button>
      <span i18n>Shipments</span>
    </div>
    <div class="menu-button" routerLink="/invoices">
      <button matButton><app-icon icon="invoice"></app-icon></button>
      <span i18n>Invoices</span>
    </div>
    <div class="menu-button" routerLink="/pickups">
      <button matButton><app-icon icon="pickup"></app-icon></button>
      <span i18n>Pickups</span>
    </div>
    <div class="menu-button" routerLink="/addresses">
      <button matButton><app-icon icon="address-books"></app-icon></button>
      <span i18n>Addresses</span>
    </div>
    <div class="menu-button" routerLink="/batches">
      <button matButton><app-icon icon="batch"></app-icon></button>
      <span i18n>Batches</span>
    </div>
    <div class="menu-button" routerLink="/library">
      <button matButton><app-icon icon="books"></app-icon></button>
      <span i18n>Library</span>
    </div>
    <div class="menu-button" routerLink="/settings">
      <button matButton><app-icon icon="settings"></app-icon></button>
      <span i18n>Settings</span>
    </div>
  </div>
